import jsPDF from "jspdf";
import "../../../../assets/font/THSarabunNew-normal";
import "../../../../assets/font/THSarabunNew-bold";
import dayjs from "dayjs";
import { ArabicNumberToText } from "../../receivePayment/thai/thaibath";
import P1 from "../../receivePayment/Pic/P1.jpg";
import P2 from "../../receivePayment/Pic/P2.png";
import P3 from "../../receivePayment/Pic/P3.jpg";
import P4 from "../../receivePayment/Pic/P4.png";
import P5 from "../../receivePayment/Pic/P5.png";

const QRCODE_URL =
  "https://asia-east2-fir-express-c1aec.cloudfunctions.net/aa/loans";

const userPrint = `กานดาวศรี แพนจำปา`;

// ─── helpers ────────────────────────────────────────────────
const str = (v) => (v === null || v === undefined ? "" : String(v));

const currencyFormatOne = (amount) => {
  if (amount) {
    return Number(amount)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");
  }
  return "-";
};

// โหลดรูปจาก URL / imported asset -> dataURL (จำเป็นสำหรับ pdf.addImage)
const urlToDataURL = (url) =>
  new Promise((resolve) => {
    if (!url) return resolve(null);
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth || 300;
        canvas.height = img.naturalHeight || 300;
        canvas.getContext("2d").drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      } catch {
        resolve(null);
      }
    };
    img.onerror = () => resolve(null);
    img.src = url;
  });

// ─── main export ────────────────────────────────────────────
export const PaymentArLawyerPdfjs = async (dataPrint) => {
  if (!dataPrint) return;

  const dataCompany = dataPrint?.company;
  const dataDetail = dataPrint?.detail;
  const dataPay = dataPrint?.pay || [];

  const company = dataCompany?.[0] || {};
  const detail = dataDetail?.[0] || {};
  const first = dataPay?.[0] || {};

  const ref1 = first?.ref;
  const ref2 = first?.CODE_CONTNO;
  const qrUrl = `${QRCODE_URL}/qr/0405552000435/00/${ref1}/${ref2}/000`;

  const sumNETPAY = dataPay.reduce(
    (sum, item) => sum + (Number(item?.NETPAY) || 0),
    0,
  );

  const [p1Img, p2Img, p3Img, p4Img, p5Img, qrImg] = await Promise.all(
    [P1, P2, P3, P4, P5, qrUrl].map(urlToDataURL),
  );

  // ── pdf setup ──
  const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const setF = (style = "normal", size = 12) => {
    pdf.setFont("THSarabunNew", style);
    pdf.setFontSize(size);
  };
  const black = () => pdf.setTextColor(0, 0, 0);

  const pageW = 210;
  const mL = 14;
  const mR = 14;
  const xR = pageW - mR;
  const contentW = xR - mL;

  const box = (x, y, w, h) => {
    pdf.setDrawColor(0, 0, 0);
    pdf.setLineWidth(0.2);
    pdf.rect(x, y, w, h, "S");
  };

  // ── ส่วนใบนำฝากธนาคาร (ใช้ซ้ำ 2 รอบ: ส่วนของลูกค้า / ส่วนของธนาคาร) ──
  // เลย์เอาต์ทั้งหมดอ้างอิงจาก startY แบบตายตัว (ไม่สะสมค่า y คลาดเคลื่อน) เพื่อกันข้อความ/รูปทับกัน
  const drawBankSlip = (startY, { title, showQr }) => {
    const y0 = startY;

    setF("bold", 12);
    black();
    pdf.text("ค่าสินค้าหรือบริการ (Bill Payment Pay-in-slip)", mL, y0);
    setF("bold", 12);
    pdf.text(title, xR, y0, { align: "right" });

    setF("normal", 12);
    pdf.text(str(company.COMP_NM), mL, y0 + 6);
    setF("bold", 12);
    pdf.text("โปรดเรียกเก็บค่าธรรมเนียมจากผู้ชำระเงิน", xR, y0 + 6, {
      align: "right",
    });

    setF("normal", 12);
    pdf.text(`${str(company.COMP_ADR1)} โทร.${str(company.TELP)}`, mL, y0 + 11);
    box(140, y0 + 8, 26, 5);
    setF("normal", 12);
    pdf.text("สาขา", 142, y0 + 11.5);
    box(168, y0 + 8, 28, 5);
    pdf.text("วันที่", 170, y0 + 11.5);

    // ── ไอคอนธนาคาร (ซ้าย) ──
    const bankLineY = [y0 + 17, y0 + 21.2, y0 + 25.4];
    const bankIcon = (idx, img, text) => {
      const ly = bankLineY[idx];
      box(mL, ly - 3, 3, 3);
      if (img) pdf.addImage(img, "PNG", mL + 5, ly - 3.5, 4, 4);
      setF("normal", 12);
      black();
      pdf.text(text, mL + 11, ly);
    };
    bankIcon(0, p1Img, "ธ.กสิกรไทย A/C No. (15/20)");
    bankIcon(1, p2Img, "ธ.กรุงไทย A/C No. CODE : 6624 (15)");
    bankIcon(2, p3Img, "ธ. ไทยพานิชย์ A/C No. (Bill Payment) (15/20)");

    // ── กล่องข้อมูลลูกค้า (ขวา) ──
    const custBoxX = 140;
    const custBoxW = xR - custBoxX;
    box(custBoxX, y0 + 15, custBoxW, 15);
    setF("normal", 12);
    black();
    pdf.text(
      pdf.splitTextToSize(
        `ชื่อลูกค้า ${str(first.NAME1)} ${str(first.NAME2)}`,
        custBoxW - 4,
      ),
      custBoxX + 2,
      y0 + 19,
    );
    pdf.text(`Ref. No.1  ${str(ref1)}`, custBoxX + 2, y0 + 24);
    pdf.text(`Ref. No.2  ${str(ref2)}`, custBoxX + 2, y0 + 29);

    // ── ไอคอนช่องทางอื่น (เต็มความกว้าง) ──
    const chLineY = [y0 + 29.6, y0 + 33.8];
    const chIcon = (idx, img, text) => {
      const ly = chLineY[idx];
      box(mL, ly - 3, 3, 3);
      if (img) pdf.addImage(img, "PNG", mL + 5, ly - 3.5, 4, 4);
      setF("normal", 12);
      black();
      pdf.text(text, mL + 11, ly);
    };
    // chIcon(0, p4Img, "เคาน์เตอร์เซอร์วิส");
    chIcon(1, p5Img, "เทสโก้โลตัส และ เทสโก้โลตัส เอ็กซ์เพรส");

    // ── แถวจำนวนเงิน (รับชำระเป็นเงินสดเท่านั้น / จำนวนเงิน / บาท) ──
    const amtY = y0 + 43;
    const amtCol1W = 55;
    const amtCol3W = 20;
    const amtCol2W = contentW - amtCol1W - amtCol3W;
    // box(mL, amtY, amtCol1W, 6);
    setF("bold", 12);
    black();
    pdf.text("รับชำระเป็นเงินสดเท่านั้น", mL + 2, amtY + 4.3);
    box(mL + amtCol1W, amtY, amtCol2W, 6);
    setF("normal", 12);
    pdf.text("จำนวนเงิน/Amount", mL + amtCol1W + 10, amtY + 4);
    box(mL + amtCol1W + amtCol2W, amtY, amtCol3W, 6);
    pdf.text("บาท/Baht", mL + amtCol1W + amtCol2W + 2, amtY + 4);

    // ── แถวจำนวนเงินเป็นตัวอักษร ──
    const wordsY = amtY + 7;
    box(mL, wordsY, 70, 6);
    setF("normal", 12);
    pdf.text("จำนวนเงินเป็นตัวอักษร/Amount in Words", mL + 2, wordsY + 4);
    box(mL + 70, wordsY, contentW - 70, 6);

    // ── แถวล่างสุด: ผู้นำฝาก / โทรศัพท์ + กล่องธนาคาร + QR ──
    const bottomY = wordsY + 12;
    setF("normal", 12);
    black();
    pdf.text("ผู้นำฝาก / Deposit By ..........................", mL, bottomY);
    pdf.text(
      "โทรศัพท์ / Telephone ..........................",
      mL,
      bottomY + 5,
    );

    const bankBoxX = 140;
    const bankBoxW = xR - bankBoxX;
    const bankBoxY = bottomY - 4;
    box(bankBoxX, bankBoxY, bankBoxW, 14);
    setF("normal", 11);
    pdf.text("สำหรับเจ้าหน้าที่ธนาคาร", bankBoxX + 2, bankBoxY + 4);
    pdf.setDrawColor(0, 0, 0);
    pdf.setLineWidth(0.15);
    pdf.line(
      bankBoxX + 1,
      bankBoxY + 5.5,
      bankBoxX + bankBoxW - 1,
      bankBoxY + 5.5,
    );
    pdf.text(
      "ผู้รับเงิน ......................................",
      bankBoxX + 2,
      bankBoxY + 11,
    );

    if (showQr && qrImg) {
      const qSize = 20;
      const qx = mL + 86;
      pdf.addImage(qrImg, "PNG", qx, bankBoxY, qSize, qSize);
    }

    return bankBoxY + 14;
  };

  const ROWS_PER_PAGE = 6;
  const pageCount = Math.max(1, Math.ceil(dataPay.length / ROWS_PER_PAGE));

  for (let p = 0; p < pageCount; p++) {
    if (p > 0) pdf.addPage();

    const startIndex = p * ROWS_PER_PAGE;
    const items = dataPay.slice(startIndex, startIndex + ROWS_PER_PAGE);
    const isLastPage = p === pageCount - 1;
    console.log("-PaymentArLawyerPdfjs-");

    // ── หัวใบเสร็จ ──
    setF("bold", 22);
    black();
    pdf.text("ใบเสร็จรับเงิน", pageW / 2, 16, { align: "center" });

    if (first.FLAG === "C") {
      setF("bold", 16);
      pdf.setTextColor(220, 0, 0);
      pdf.text("ยกเลิก", xR, 16, { align: "right" });
      black();
    }

    setF("normal", 12);
    pdf.text(str(company.COMP_NM), mL, 23);
    pdf.text(str(company.COMP_ADR1), mL, 28);
    pdf.text(str(company.TELP), mL, 33);

    setF("normal", 12);
    pdf.text(`เลขที่ใบเสร็จ : ${str(first.TMBILL)}`, xR, 23, {
      align: "right",
    });
    pdf.text(
      `วันที่พิมพ์ : ${first.PAYDT ? dayjs(first.PAYDT).format("DD/MM/YYYY") : ""}`,
      xR,
      28,
      { align: "right" },
    );
    pdf.text(`เลขที่สัญญา : ${str(first.CONTNO)}`, xR, 33, { align: "right" });

    // ── ข้อมูลลูกค้า / รถ ──
    setF("normal", 12);
    pdf.text(`ชื่อลูกค้า : ${str(first.NAME1)} ${str(first.NAME2)}`, mL, 40);
    setF("normal", 12);
    pdf.text(
      `ยี่ห้อ ${str(detail.TYPE)} รุ่น ${str(detail.MODEL)} สี ${str(detail.COLOR)}`,
      xR,
      40,
      { align: "right" },
    );

    pdf.text(
      `ที่อยู่ : ${str(detail.ADDRES)} ${str(detail.SOI)} ${str(detail.TUMB)}`,
      mL,
      45,
    );
    pdf.text(
      `เลขตัวถัง ${str(detail.STRNO)} ทะเบียน ${str(detail.REGNO)}`,
      xR,
      45,
      { align: "right" },
    );

    pdf.text(
      `${str(detail.AUMP)} ${str(detail.PROVDES)} ${str(detail.ZIP)} โทร.${str(
        detail.TELP,
      )}`,
      mL,
      50,
    );

    pdf.text(
      `ชำระโดย : ${str(first.PAYDESC)} ${
        first.DOSBILL !== "" ? str(first.DOSBILL) : ""
      }`,
      mL,
      55,
    );

    // ── ตารางรายการชำระ (วาดเส้นเอง แทน autoTable) ──
    const tableHeaders = [
      "ลำดับ",
      "ชำระค่า",
      "หักเงินต้น",
      "ดอกเบี้ย",
      "ส่วนลด",
      "ค่าทวงถาม",
      "ลดค่าทวงถาม",
      "รับสุทธิ",
      "ยอดเงินคงเหลือ",
    ];
    const colWidths = [16, 28, 16, 16, 14, 20, 20, 26, 26];
    const colAligns = [
      "center",
      "left",
      "right",
      "right",
      "right",
      "right",
      "right",
      "right",
      "right",
    ];
    const colX = [mL];
    colWidths.forEach((w) => colX.push(colX[colX.length - 1] + w));

    // วาดกรอบแถว + เส้นแบ่งคอลัมน์ (ข้ามคอลัมน์ที่ถูก merge ด้วย colSpan)
    const drawRowBorders = (rowY, rowH, spans) => {
      pdf.setDrawColor(0, 0, 0);
      pdf.setLineWidth(0.2);
      pdf.rect(mL, rowY, contentW, rowH, "S");
      const skip = new Set();
      if (spans) {
        let idx = 0;
        spans.forEach((span) => {
          for (let k = 1; k < span; k++) skip.add(idx + k);
          idx += span;
        });
      }
      for (let i = 1; i < colWidths.length; i++) {
        if (!skip.has(i)) pdf.line(colX[i], rowY, colX[i], rowY + rowH);
      }
    };

    // วาดเฉพาะเส้นแบ่งคอลัมน์ (แนวตั้ง) ของแถว โดยไม่มีเส้นคั่นบน-ล่างระหว่างแถว
    const drawColLines = (rowY, rowH) => {
      pdf.setDrawColor(0, 0, 0);
      pdf.setLineWidth(0.2);
      for (let i = 1; i < colWidths.length; i++) {
        pdf.line(colX[i], rowY, colX[i], rowY + rowH);
      }
    };

    // วาดข้อความในเซลล์ (รองรับหลายบรรทัด + colSpan) จัดกึ่งกลางแนวตั้ง
    const drawCell = (lines, ci, span, rowY, rowH, align) => {
      const text = Array.isArray(lines) ? lines : [lines];
      const w = colX[ci + span] - colX[ci];
      const pad = 2;
      let tx;
      if (align === "center") tx = colX[ci] + w / 2;
      else if (align === "right") tx = colX[ci + span] - pad;
      else tx = colX[ci] + pad;
      const lineH = 4.2;
      const totalH = text.length * lineH;
      let ly = rowY + rowH / 2 - totalH / 2 + lineH - 1.3;
      text.forEach((ln) => {
        pdf.text(ln, tx, ly, { align });
        ly += lineH;
      });
    };

    let ty = 59;

    // ── header ──
    setF("bold", 12);
    black();
    const headerLines = tableHeaders.map((h, i) =>
      pdf.splitTextToSize(h, colWidths[i] - 3),
    );
    const headerH = Math.max(
      7,
      Math.max(...headerLines.map((l) => l.length)) * 4.2 + 2.6,
    );
    pdf.setFillColor(235, 235, 235);
    pdf.rect(mL, ty, contentW, headerH, "F");
    drawRowBorders(ty, headerH);
    headerLines.forEach((lines, i) =>
      drawCell(lines, i, 1, ty, headerH, "center"),
    );
    ty += headerH;

    // ── body ──
    setF("normal", 12);
    black();
    const rowH = 7;
    const bodyStartY = ty;
    items.forEach((item, i) => {
      const rowVals = [
        str(startIndex + i + 1),
        str(item.FORDESC),
        currencyFormatOne(item.PAYAMT_N),
        currencyFormatOne(item.PAYAMT_V),
        currencyFormatOne(item.DISCT),
        currencyFormatOne(item.INTAMT),
        currencyFormatOne(item.DIFINTAMT),
        currencyFormatOne(item.NETPAY),
        currencyFormatOne(item.Balance),
      ];
      drawColLines(ty, rowH);
      rowVals.forEach((v, ci) => drawCell(v, ci, 1, ty, rowH, colAligns[ci]));
      ty += rowH;
    });
    pdf.setDrawColor(0, 0, 0);
    pdf.setLineWidth(0.2);
    pdf.rect(mL, bodyStartY, contentW, ty - bodyStartY, "S");

    // ── footer: สรุปยอดรวม (เฉพาะหน้าสุดท้าย) ──
    if (isLastPage) {
      setF("normal", 12);
      const wordsLines = pdf.splitTextToSize(
        ArabicNumberToText(sumNETPAY),
        colWidths[2] + colWidths[3] + colWidths[4] + colWidths[5] - 4,
      );
      const footH = Math.max(7, wordsLines.length * 4.2 + 2.6);
      drawRowBorders(ty, footH, [2, 4, 1, 2]);

      setF("bold", 12);

      drawCell("จำนวนเงินเป็นตัวอักษร", 0, 2, ty, footH, "left");
      setF("normal", 12);
      drawCell(wordsLines, 2, 4, ty, footH, "center");
      setF("bold", 12);
      drawCell("จำนวนเงิน", 6, 1, ty, footH, "center");
      drawCell(currencyFormatOne(sumNETPAY), 7, 2, ty, footH, "right");

      ty += footH;
    }

    let y = ty + 5;

    // ── ลายเซ็นใบเสร็จ ──

    setF("bold", 12);
    black();
    pdf.text(
      pdf.splitTextToSize(
        "ใบเสร็จรับเงินฉบับนี้จะสมบูรณ์เมื่อปรากฎลายเซ็นของผู้รับเงินครบถ้วนและเช็คของท่านผ่านบัญชีบริษัทฯ เรียบร้อยแล้ว",
      ),
      mL,
      y,
    );
    setF("bold", 12);
    pdf.text(`ผู้รับเงิน ${userPrint}`, xR, y + 2, { align: "right" });
    y += 5;
    setF("bold", 12);
    pdf.text("( ออกโดยระบบอัตโนมัติ )", xR, y, { align: "right" });

    y += 3;
    pdf.setDrawColor(0, 0, 0);
    pdf.setLineWidth(0.3);
    pdf.line(mL, y, xR, y);

    // ── ใบนำฝากธนาคาร: ส่วนของลูกค้า / ส่วนของธนาคาร ──
    y += 6;
    y = drawBankSlip(y, { title: "ส่วนของลูกค้า", showQr: false });

    y += 3;
    pdf.line(mL, y, xR, y);
    y += 6;
    drawBankSlip(y, { title: "ส่วนของธนาคาร", showQr: true });
  }

  // ── เปิด / สั่งพิมพ์ ──
  const blob = pdf.output("blob");
  const url = URL.createObjectURL(blob);
  const win = window.open(url);
  if (win) win.onload = () => win.print();
  else alert("กรุณาปิดการบล็อกป๊อปอัปเพื่อใช้งานฟังก์ชันนี้");
};

export default PaymentArLawyerPdfjs;
